import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyNarrowViewportShim } from './app/narrow-viewport-shim';

if (environment.production) {
  enableProdMode();

  if( window ) {
    window.console.log = () => {};
  }
}

// Before bootstrap so the first layout already uses the corrected viewport.
applyNarrowViewportShim();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
